import React, { useState } from 'react';
import { connect } from 'react-redux';
import MasterComponent from '../../../../../components/Forms';
import ShortListedConfig from '../../../../../entity/HRM/pre-onboarding/shortlistedConfig';
import { Button, Tag, Typography, Modal } from 'antd';
import { MasterConfigs } from '../../../../../interfaces/entity';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { postData, putData } from '../../../../../actions/developer';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { constants } from '../../../../../constants/common';
import NextRoundModal from '../../tabs/Screening/modal';
import FormSetup from '../../../../../components/Forms/FormSetup';

const { confirm } = Modal;

const OfferAcceptance = () => {
  const level = constants.PROFILE_STATUS.ACCEPTANCE;
  const [nextRound, setNextRound] = useState(false)
  const [candidateType, setCandidateType] = useState(null)
  const [selected, setSelectedRow] = useState([])
  const [sendForm, setSendForm] = useState(false)
  const [selectedRow, setSelected] = useState<any>({})
  const dispatch = useDispatch();

  const OverriddenConfig: MasterConfigs = {
    ...ShortListedConfig,
    api: () => ShortListedConfig.api() + '/' + level,
    tableProps: {
      rowSelection: {
        ...ShortListedConfig.rowSelection,
        onChange: (selectedRowKeys, selectedRows) => {
          setSelectedRow(selectedRows)
        },
      },
    },
    // isActionTab: true,
    actions: [...ShortListedConfig.actions, selected.length > 0 && { name: 'move to next', actionType: 'Add', onClick: () => onMoveToNext() }],
    getColumns: () => [
      ...ShortListedConfig.getColumns(),
      {
        title: 'Offerd CTC',
        key: '',
        dataIndex: '',
        width: 150,
        render: (text) => {
          return <Typography.Title level={5} editable={{
            onChange: (e) => onOfferedCTC(e, text),
          }}>{text?.offeredCTC}</Typography.Title>
        }
      },
      {
        title: 'Form Link',
        dataIndex: '',
        key: '',
        width: 150,
        render: (text) => {
          if (text && text.requestFormAt) {
            return <Tag color='blue' onClick={() => confirmationlink(text)}>{moment(text?.requestFormAt).format('lll')}</Tag>
          } else {
            return <Button onClick={() => confirmationlink(text)}>Send</Button>
          }
        },
      }
    ],
    getFormColumns: () => [
      ...ShortListedConfig.getFormColumns().map(ele => {
        if (ele.name == 'candidateType') {
          return {
            ...ele,
            selectProps: {
              onChange: (text) => {
                setCandidateType(text);
              }
            }
          }
        } else {
          if (ele.name == "experiance") {
            if (candidateType == 'Experience') {
              return ele
            } else {
              return
            }
          } else {
            return ele
          }
        }
      }).filter(Boolean)
    ]
  };

  const formConfig: MasterConfigs = {
    api: () => ShortListedConfig.api() + '/book',
    modalTitle: () => 'Send Request Form',
    onSubmit: async (id, data) => {
      sendLink({ ids: selectedRow._id, ...data });
      return { code: 200, message: 'Success' }
    },
    onRefresh: () => {
      setSelected(null)
      setSendForm(false)
    },
    getFormColumns: () => [
      {
        label: 'Form',
        name: 'form',
        type: 'select',
        rules: [{ required: true, message: 'Please select form' }],
        isCombo: true
      }
    ],
    combo: [
      {
        api: '/doccument-folders',
        name: 'form',
        idKey: '_id',
        render: (item) => {
          return <div>{item.name}</div>
        }
      }
    ]
  }

  const confirmationlink = async (item) => {
    setSelected(item)
    setSendForm(true)
  }

  const sendLink = async (item) => {
    const resData = await dispatch(postData(ShortListedConfig.api() + '/' + level + '/send/doccument/request', item));
    if (resData) {
      onRefresh()
    }
  }

  const onOfferedCTC = async (text, item) => {
    if (text != item.offeredCTC) {
      const resData = await dispatch(putData(ShortListedConfig.api() + '/' + level + '/' + item._id, { offeredCTC: text }));
      if (resData) {
        onRefresh()
      }
    }
  }

  const onRefresh = () => {
    dispatch({
      type: 'REFRESH_TABLE',
      refreshTable: true
    })
  }


  const onMoveToNext = () => {
    setNextRound(true)
  }

  return <React.Fragment>
    <FormSetup config={formConfig} open={sendForm} onClose={() => {
      setSelected(null)
      setSendForm(false)
    }} isModal={true} id={selectedRow?._id} />
    <NextRoundModal isVisible={nextRound} onClose={() => setNextRound(false)} selected={selected} level={level} />
    <MasterComponent config={OverriddenConfig} />
  </React.Fragment>
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(OfferAcceptance);
